'use client';

import { usePathname } from 'next/navigation';
import React, { ReactNode } from 'react';
import { cn } from '@/helpers/cn';
import Link from 'next/link';
import { Route } from 'next';

interface NavbarItemProps {
    id: string;
    title: string;
    href: Route;
    icon: ReactNode;
    active: {
        icon: ReactNode;
        textColor: string;
        bgColor: string;
    };
    showBadge?: boolean;
}

export default function NavbarItem({ title, href, id, icon, active, showBadge }: NavbarItemProps) {
    const pathname = usePathname();
    const isActive = pathname === href;

    return (
        <Link
            id={id}
            className={cn(
                'flex items-center justify-center gap-2 text-base font-bold leading-6 rounded-full relative h-[52px] [transition:width_0.3s_ease]',
                isActive ? 'w-full sm:px-6' : 'min-w-8 w-8'
            )}
            style={{
                backgroundColor: isActive ? `${active.bgColor}` : ''
            }}
            aria-label={`تب-${title}`}
            href={href}>
            {isActive ? active.icon : icon}
            {isActive && (
                <span
                    style={{
                        color: isActive ? `${active.textColor}` : ''
                    }}>
                    {title}
                </span>
            )}
            {!!showBadge && !isActive && (
                <span className="w-2 h-2 bg-error rounded-full aspect-square absolute top-3 left-0" />
            )}
        </Link>
    );
}
